"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-explicit-any */
const camelCase_1 = tslib_1.__importDefault(require("lodash/camelCase"));
const capitalize_1 = tslib_1.__importDefault(require("lodash/capitalize"));
const cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isBoolean_1 = tslib_1.__importDefault(require("lodash/isBoolean"));
const isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
const isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
const isMatch_1 = tslib_1.__importDefault(require("lodash/isMatch"));
const isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
const isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
const isUndefined_1 = tslib_1.__importDefault(require("lodash/isUndefined"));
const kebabCase_1 = tslib_1.__importDefault(require("lodash/kebabCase"));
const split_1 = tslib_1.__importDefault(require("lodash/split"));
const ObjectHelper = {
    // Only prototype format which ensure no eslint error in the code
    isObject: (value) => {
        return (0, isObject_1.default)(value);
    },
    isEmpty: (value) => {
        return (0, isEmpty_1.default)(value);
    },
    cloneDeep: (value) => {
        return (0, cloneDeep_1.default)(value);
    },
    isGuid: (object) => {
        const regex = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
        return regex.test(object);
    },
    isNil: (value) => {
        return (0, isNil_1.default)(value);
    },
    isEqual: (value, other) => {
        return (0, isEqual_1.default)(value, other);
    },
    isBoolean: (value) => {
        return (0, isBoolean_1.default)(value);
    },
    split: (value, separator, limit) => {
        return (0, split_1.default)(value, separator, limit);
    },
    camelCase: (value) => {
        return (0, camelCase_1.default)(value);
    },
    kebabCase: (value) => {
        return (0, kebabCase_1.default)(value);
    },
    isMatch: (value, source) => {
        return (0, isMatch_1.default)(value, source);
    },
    // Only prototype format which ensure no eslint error in the code
    isArray: (value) => {
        return (0, isArray_1.default)(value);
    },
    get: (value, path, defaultValue) => {
        return (0, get_1.default)(value, path, defaultValue);
    },
    capitalize: (value) => {
        return (0, capitalize_1.default)(value);
    },
    isUndefined: (value) => {
        return (0, isUndefined_1.default)(value);
    },
    getString: (label) => {
        return label ?? "";
    },
    getList: (list) => {
        return list ?? [];
    },
    getStringifyObject: (object) => {
        return typeof object === "string" ? object : JSON.stringify(object);
    },
};
exports.default = ObjectHelper;
//# sourceMappingURL=ObjectHelper.js.map